export default function Main(data) {
  try {
    // Check if data is valid base64
    if (!data || typeof data !== 'string') {
      console.warn('Decrypt: Invalid data provided')
      return null
    }
    
    // Try to decode base64
    const decoded = window.atob(data)
    
    // Try to parse as JSON
    return JSON.parse(decoded)
  } catch (error) {
    console.warn('Decrypt: Failed to decode/parse data:', error.message)
    return null
  }
}
